import { useQuery } from '@tanstack/react-query'
import { getRequest } from 'utils/http'

export const useGetTickets = (page = 1, pageSize = 10, searchQuery = '', filters = {}) => {
  const { event_id = '', tier_id = '', status = '' } = filters
  return useQuery({
    queryKey: ['tickets', page, pageSize, searchQuery, event_id, tier_id, status],
    queryFn: async () => {
      const response = await getRequest('tickets', {
        params: {
          page,
          pageSize,
          searchQuery,
          event_id: event_id || undefined,
          tier_id: tier_id || undefined,
          status: status || undefined,
        }
      })
      return response
    },
    keepPreviousData: true
  })
}
